import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

/**
 * 
 * @param {*} props.color - The color of the skeleton loader.
 * @param {*} props.count - The number of skeleton lines to display.
 * @param {*} props.height - The height of the skeleton loader.
 * @param {*} props.width - The width of the skeleton loader.
 * @param {*} props.style - Additional styles to apply to the skeleton loader.
 * @param {*} props.className - Additional class names to apply to the skeleton loader.
 * @param {*} props.baseColor - The base color of the skeleton loader.
 * @param {*} props.highlightColor - The highlight color of the skeleton loader.
 * @param {*} props.duration - The duration of the skeleton animation in seconds.
 * @param {*} props.borderRadius - The border radius of the skeleton loader.
 * CustomSkeleton component that wraps the react-loading-skeleton library's Skeleton component.
 * It allows for easy customization of skeleton loading elements in the application.
 * 
 * @returns {JSX.Element} - A Skeleton component with the provided props. 
 */

const CustomSkeleton = (props) => {
    return <Skeleton {...props}/>
}

export default CustomSkeleton